export enum reserved {
  changeMode = "changeMode",
  lightMode = "light",
  darkMode = "dark",
  isLoading = "isLoading",
}
